import { ReactNode } from 'react'
import { HeaderContext, Table } from '@tanstack/react-table'
import { mkConfig, generateCsv, download, ColumnHeader } from 'export-to-csv'

export function csvLabeledHeader<T>(
  csvHeader: string,
  render: (ctx: HeaderContext<T, unknown>) => ReactNode,
) {
  const wrapped = (ctx: HeaderContext<T, unknown>) => render(ctx)
  return Object.assign(wrapped, { csvHeader })
}

export function csvHeadersFromTable<T>(table: Table<T>): ColumnHeader[] {
  return table.getAllLeafColumns().map((col) => {
    const header = col.columnDef.header
    const displayLabel =
      typeof header === 'function' && 'csvHeader' in header
        ? (header as { csvHeader: string }).csvHeader
        : header?.toString() || ''
    return { key: col.id, displayLabel }
  })
}

export function downloadTableCsv<T>({
  table,
  headers,
  filename = 'export',
}: {
  table: Table<T>
  headers: ColumnHeader[]
  filename?: string
}) {
  const csvConfig = mkConfig({ columnHeaders: headers, filename })

  const data = table.getRowModel().rows.map((r) =>
    table.getAllLeafColumns().reduce(
      (acc, col) => ({
        ...acc,
        [col.id]: r.getValue(col.id),
      }),
      {},
    ),
  )
  const csv = generateCsv(csvConfig)(data)
  download(csvConfig)(csv)
}
